<template>
  <b-container fluid>
    <b-row>
      <b-col md="12" class="text-right">
        <b-button
          id="create-new-consignment"
          variant="success"
          @click="openFormToAddConsignment"
          class="ml-3 mr-3">
          <i class="fas fa-plus"></i><span>Создать виртуальный пакет</span>
        </b-button>
      </b-col>
    </b-row>

    <b-table
      hover
      show-empty
      fixed
      id="data_table"
      :fields="fields"
      :items="parsedConsignments"
      :busy="isBusy"
      :no-provider-paging="true"
      :no-provider-sorting="true"
      :no-provider-filtering="true"
      :current-page="currentPage"
      :per-page="perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @row-hovered="rowHowered"
      @row-unhovered="rowUnhowered"
      class="mt-3 blue"
      empty-text="Нет данных в таблице"
      empty-filtered-text="Нет данных по вашему запросу">

      // загрузчик
      <div slot="table-busy" class="text-center text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загрузка...</strong>
      </div>

      // Информация
      <template slot="HEAD_id" slot-scope="data">
        <i class="fas fa-info-circle"></i>{{ data.label }}
      </template>
      <template slot="id" slot-scope="row">
        <div>{{ row.item.info }}</div>
      </template>

      // Дата создания
      <template slot="HEAD_create_date" slot-scope="data">
        <i class="fas fa-calendar"></i>{{ data.label }}
      </template>
      <template slot="create_date" slot-scope="row">
        <div>{{ convertDate(row.value) }}</div>
      </template>

      // Дата модификации
      <template slot="HEAD_modify_date" slot-scope="data">
        <i class="fas fa-calendar-check"></i>{{ data.label }}
      </template>
      <template slot="modify_date" slot-scope="row">
        <div>{{ convertDate(row.value) }}</div>
      </template>

      // Действия
      <template slot="HEAD_show_details" slot-scope="data">
        <i class="fas fa-info-circle"></i>{{ data.label }}
      </template>
      <template slot="show_details" slot-scope="row">
        <div class="actions-wrapper">
          <div v-show="row.item.actions.visible">
            <b-button id="open-documents-btn" variant="outline-secondary" class="actions-with-outline"
                      @click="row.toggleDetails">
              <i class="fas fa-paperclip"></i>
            </b-button>
            <b-button id="edit-consignment-btn" variant="outline-secondary" class="actions-with-outline"
                      @click="openFormToEditConsignment($event, row.item.id)">
              <i class="fas fa-reply"></i>
            </b-button>
            <b-button id="piportal-upload-consignment-btn" variant="outline-secondary" class="actions-with-outline"
                      @click="piportalUploadConsignment({ 'id': row.item.id })">
              <i class="fas fa-upload"></i>
            </b-button>
          </div>
          <b-button variant="outline-secondary" :id="(row.item.id).toString()" class="actions-without-outline">
            <i class="fas fa-ellipsis-h"></i>
          </b-button>
          <b-popover :target="(row.item.id).toString()" triggers="focus">
            <b-list-group>
              <b-list-group-item
                class="border-top-0 border-left-0 border-right-0 border-bottom-0"
                @click="row.toggleDetails">
                <i class="fas fa-paperclip" style="color: #78909C"></i><span class="ml-2">Документы</span>
              </b-list-group-item>
              <b-list-group-item
                class="border-bottom-0 border-left-0 border-right-0"
                @click="openFormToEditConsignment($event, row.item.id)">
                <i class="fas fa-reply" style="color: #E7161A"></i><span class="ml-2">Редактировать</span>
              </b-list-group-item>
              <b-list-group-item
                class="border-bottom-0 border-left-0 border-right-0"
                @click="piportalUploadConsignment({ 'id': row.item.id })">
                <i class="fas fa-upload" style="color: #78909C"></i><span class="ml-2">Отправить</span>
              </b-list-group-item>
            </b-list-group>
          </b-popover>
        </div>
      </template>

      // Файлы
      <template slot="row-details" slot-scope="row">
        <div v-if="row.item.files && row.item.files.length > 0" class="attachments-wrapper">
          <div v-for="file in row.item.files"
               :key="file.name"
               class="attachment"
               :style="{ width: attachmentWidth + 'px', position: 'relative' }"
               :title="file.name"
               @click="loadFile($event, file.file)">
            <div class="attachment-inner-container">
              <div class="file-icon-wrapper">
                <i :class="[file.icon, 'file-icon']"></i>
              </div>
              <div class="attachment-name-wrapper">
                <div class="mb-5 mr-4">{{ file.name }}</div>
                <span class="badge badge-secondary file-size" v-html="calcFileSize(5600)"></span>
              </div>
            </div>
          </div>
          <div v-if="!row.item.files.length" style="padding-bottom: 16px">
            В этом пакете нет файлов
          </div>
        </div>
      </template>
    </b-table>

    <div class="main-footer">
      <b-form inline>
        <label class="mr-3">Показать</label>
        <b-form-select :options="pageOptions" v-model="perPage"/>
      </b-form>
      <b-pagination align="center"
                    prev-text="&lt;"
                    first-text="&lt;&lt;"
                    next-text="&gt;"
                    last-text="&gt;&gt;"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-6">
      </b-pagination>
    </div>

    <b-modal id="modalCreateConsignment"
             title="Создание виртуального пакета"
             size="lg"
             hide-footer
             @show="inputUpdate([]); sendPackageVariable=false"
             @hide="validateChanges"
             @hidden="url=null; consignmentsInfo=''">
      <modal-package-form
        :attachmentWidth="attachmentWidth"
        :consignmentsInfo="consignmentsInfo"
        :modalCreateConsignment=true
        :deletedFilesCount="deletedFilesCount"
        @update_consignments_info="updateConsignmentsInfo"
        @save="saveNewConsignment($event)"
      ></modal-package-form>
    </b-modal>

    <b-modal id="modalEditConsignment"
             title="Редактирование виртуального пакета"
             size="lg"
             hide-footer
             @show="inputUpdate([]); sendPackageVariable=false"
             @hide="validateChanges"
             @hidden="url=null; consignmentsInfo=''; deletedFilesCount=0; editFiles=[]">
      <modal-package-form
        :attachmentWidth="attachmentWidth"
        :consignmentsInfo="consignmentsInfo"
        :editFiles="editFiles"
        :modalEditConsignment=true
        :deletedFilesCount="deletedFilesCount"
        @update_consignments_info="updateConsignmentsInfo"
        @remove="removeFileFromEditedFiles"
        @edit="saveEditedConsignment($event)"
      ></modal-package-form>
    </b-modal>

    <b-modal
      class="package-modal"
      id="modalLoadFile"
      size="xl"
      hide-footer>
      <div class="iframe-wrapper">
        <iframe :src="url"></iframe>
      </div>
    </b-modal>

  </b-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'Consignments',
  components: {
    ModalPackageForm: () => import('./ModalPackageForm')
  },
  data () {
    return {
      consignmentsInfo: '',
      url: null,
      createForm: false,
      editConsignmentId: null,
      editFiles: [],
      filesToDelete: [],
      maxFileSize: 0,
      attachmentWidth: null,
      deletedFilesCount: 0,
      sendPackageVariable: false,
      fields: [
        { key: 'id', label: 'Информация', sortable: false },
        { key: 'create_date', label: 'Дата создания', sortable: false },
        { key: 'modify_date', label: 'Дата модификации', sortable: false },
        { key: 'show_details', label: 'Действия', sortable: false, tdClass: 'align-middle' }
      ],
      filterStatus: [],
      filterData: [],
      isBusy: false,
      currentPage: 1,
      totalRows: null,
      perPage: 10,
      pageOptions: [10, 20, 50],
      sortBy: 'id',
      sortDesc: true,
      sortDirection: 'desc'
    }
  },
  mounted () {
    this.attachmentWidth = Math.round((window.innerWidth - 16 * 9 - 30) / 8)
    this.attachmentWidth = this.attachmentWidth < 218 ? 218 : this.attachmentWidth
    this.toggleBusy()
    this.loadConsignments().then(
      result => {
        this.toggleBusy()
        if (this.consignments && this.consignments.length) {
          this.totalRows = this.consignments.length
        }
      },
      error => {
        console.log(error)
      }
    )
  },
  methods: {
    ...mapActions('consignments', [
      'loadConsignments',
      'createConsignment',
      'addFilesToNewConsignment',
      'editConsignment',
      'deleteFiles',
      'piportalUploadConsignment',
      'getLatest',
      'addFilesToEditedConsignment'
    ]),
    ...mapMutations('consignments', [
      'changeAttachmentsVisibility'
    ]),
    updateConsignmentsInfo (value) {
      this.consignmentsInfo = value
    },
    rowHowered (item, index, event) {
      item.actions.visible = true
    },
    rowUnhowered (item, index, event) {
      item.actions.visible = false
    },
    toggleBusy () {
      this.isBusy = !this.isBusy
    },
    removeFileFromEditedFiles (id) {
      for (let i = 0; i < this.editFiles.length; i++) {
        if (this.editFiles[i].id === id) {
          this.editFiles[i].deleted = true
          this.deletedFilesCount++
        }
      }
    },
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    convertDate (date) {
      return this.moment(date).format('DD.MM.YYYY HH:mm')
    },
    openFormToAddConsignment () {
      this.$root.$emit('bv::show::modal', 'modalCreateConsignment', event)
      this.createForm = true
    },
    saveNewConsignment (event) {
      event.stopPropagation()
      this.sendPackageVariable = true
      this.toggleBusy()
      this.createConsignment(this.consignmentsInfo).then(
        result => {
          if (this.files.length > 0) {
            this.addFilesToNewConsignment(this.files).then(
              result => {
                this.loadConsignments()
                this.sendPackageVariable = false
                this.toggleBusy()
              },
              error => {
                console.log(error)
              }
            )
          } else {
            this.loadConsignments()
            this.toggleBusy()
          }
        },
        error => {
          console.log(error)
        }
      )
      this.$root.$emit('bv::hide::modal', 'modalCreateConsignment', event)
    },
    saveEditedConsignment () {
      event.stopPropagation()
      this.sendPackageVariable = true
      const filesToDelete = []
      for (let i = 0; i < this.editFiles.length; i++) {
        if (this.editFiles[i].deleted) {
          filesToDelete.push(this.editFiles[i].id)
        }
      }
      this.toggleBusy()
      this.editConsignment({ id: this.editConsignmentId, info: this.consignmentsInfo }).then(
        result => {
          this.addFilesToEditedConsignment({ id: this.editConsignmentId, files: this.files }).then(
            result => {
              if (filesToDelete.length > 0) {
                this.deleteFiles({ id: this.editConsignmentId, filesToDelete: filesToDelete }).then(
                  result => {
                    this.loadConsignments().then(
                      result => {
                        this.toggleBusy()
                        this.sendPackageVariable = false
                      },
                      error => {
                        console.log(error)
                      }
                    )
                  },
                  error => {
                    console.log(error)
                  }
                )
              } else {
                this.loadConsignments().then(
                  result => {
                    this.toggleBusy()
                    this.sendPackageVariable = false
                  },
                  error => {
                    console.log(error)
                  }
                )
              }
            },
            error => {
              console.log(error)
            }
          )
        },
        error => {
          console.log(error)
        }
      )
      this.$root.$emit('bv::hide::modal', 'modalEditConsignment', event)
    },
    loadFile (event, fileHref) {
      event.stopPropagation()
      this.url = fileHref
      this.$root.$emit('bv::show::modal', 'modalLoadFile', event)
    },
    openFormToEditConsignment (event, id) {
      event.stopPropagation()
      for (let i = 0; i < this.consignments.length; i++) {
        if (this.consignments[i].id === id) {
          this.editConsignmentId = id
          this.consignmentsInfo = this.consignments[i].info
          for (let q = 0; q < this.consignments[i].files.length; q++) {
            this.$set(this.editFiles, q,
              {
                name: this.consignments[i].files[q].name,
                size: this.consignments[i].files[q].size ? this.consignments[i].files[q].size : 5600,
                link: this.consignments[i].files[q].file,
                id: this.consignments[i].files[q].id,
                deleted: false,
                icon: this.consignments[i].files[q].icon
              })
          }
        }
      }
      this.$root.$emit('bv::show::modal', 'modalEditConsignment', event)
    },
    validateChanges (event) {
      if ((this.files.length > 0 || this.deletedFilesCount > 0) && (!this.sendPackageVariable)) {
        const agree = confirm('Вы действительно хотите закрыть форму? Изменения, внесенные в пакет, не сохранятся!')
        if (!agree) {
          event.preventDefault()
        }
      }
    },
    inputUpdate (files) {
      this.$store.commit('updateFiles', files)
    },
    calcFileSize (FileSize) {
      const FileSizeInKb = Math.floor(FileSize / 1024)
      let FileSizeInMb = 0
      let FileSizeInGb = 0
      if (FileSizeInKb > 0) {
        FileSizeInMb = Math.floor(FileSizeInKb / 1024)
        if (FileSizeInMb > 0) {
          FileSizeInGb = Math.floor(FileSizeInMb / 1024)
          if (FileSizeInGb > 0) {
            return '<span>' + FileSizeInGb + ' Гб</span>'
          } else {
            return '<span>' + FileSizeInMb + ' Мб</span>'
          }
        } else {
          return '<span>' + FileSizeInKb + ' Кб</span>'
        }
      } else {
        return '<span>' + FileSize + ' байт</span>'
      }
    }
  },
  computed: {
    ...mapState(
      {
        consignments: state => state.consignments.consignments,
        arrOfIcons: state => state.consignments.arrOfIcons,
        files: state => state.files
      }
    ),
    parsedConsignments () {
      return JSON.parse(JSON.stringify(this.consignments))
    }
  }
}
</script>

<style lang="scss" scoped>
  i {
    width: 20px;
    height: 20px;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    margin-right: 8px;
  }

  #create-new-consignment {
    height: 40px;
    i {
      color: #ffffff;
    }
    span {
      font-size: 14px;
      font-weight: 500;
      position: relative;
      bottom: 1px;
    }
  }

  #data_table {
    width: 100%;
    table-layout: fixed;
    .actions-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: stretch;
      div {
        height: 32px;
        .actions-with-outline {
          border-radius: 50%;
          width: 32px;
          height: 32px;
          position: relative;
          margin-right: 0.75rem;
          border: 2px solid #CFD8DC;
          i {
            position: absolute;
            top: calc((100% - 20px) / 2);
            left: calc((100% - 20px) / 2);
            font-size: 16px;
            &.fas.fa-reply {
              color: #E7161A;
            }
          }
          &:hover {
            color: #fff !important;
            cursor: pointer;
          }
        }
      }
      .actions-without-outline {
        width: 32px;
        height: 32px;
        position: relative;
        padding: 0.1rem 0.375rem;
        border-radius: 50%;
        margin-right: 0.75rem;
        border: none;
        &:hover {
          cursor: pointer;
          border: none;
          background-color: transparent;
          color: #78909C;
        }
        &:focus {
          cursor: pointer;
          border: none;
          outline: none;
          background-color: transparent;
          color: #78909C;
          box-shadow: none;
          -moz-box-shadow: none;
          -o-box-shadow: none;
          -webkit-box-shadow: none;
        }
        i {
          position: absolute;
          top: calc((100% - 18px) / 2);
          left: calc((100% - 20px) / 2);
          font-size: 21px;
        }
      }
    }
  }

  .attachments-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    .attachment {
      margin-right: 16px;
      margin-bottom: 16px;
      padding: 10px;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
      position: relative;
      &:hover {
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
        cursor: pointer;
      }
      .attachment-inner-container {
        display: flex;
        width: 100%;
        word-break: break-all;
        .file-icon-wrapper {
          margin-right: 10px;
          i {
            font-size: 32px;
            color: #78909C;
            min-height: 80px;
          }
        }
        .attachment-name-wrapper {
          font-size: 14px;
          letter-spacing: 0.25px;
          line-height: 20px;
          color: #37474F;
          .file-size {
            position: absolute;
            right: 10px;
            bottom: 10px;
          }
        }
      }
    }
  }

  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .iframe-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 25px;
    height: 0;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
</style>
